import React from 'react';
import {
  AwardsItemProps,
  linkedPartners,
  MainPrograms,
  Partner,
  StatusLevels
} from '../index';
import {
  InstructionWrapper,
  List,
  TextField
} from '../../../../components/fields';
import Heading from '../../../../_global/components/heading/Heading';
import './_styles.scss';
import { Card } from '@mui/material';
import { awardProgramCategories } from '../../../../definitions/Categories';
import { awardsDataService } from '../../services';
import { useStateReducer } from '../../../../hooks';
import { parseFloatWithDecimal } from '../../../../utilities/stringUtils';

export default function ViewItem({
  data: {
    main_program,
    display_program,
    category,
    status_levels = {
      level1: '',
      level2: '',
      level3: '',
      level4: '',
      level5: ''
    },
    programs = { name: '', partners: [{ program: '', ratio: 0 }] },
    currency = { value_cents: 0 },
    _id
  }
}: AwardsItemProps) {
  const status_levels_keys = Object.keys(status_levels) as Array<
    keyof StatusLevels
  >;
  let listLinkedPrograms: linkedPartners[] = [];
  const [state, setState] = useStateReducer({
    listLinkedPrograms,
    programs
  });

  React.useEffect(() => {
    (async function fetchTransferPrograms() {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      listLinkedPrograms = await awardsDataService.getTransferPartners(
        main_program
      );

      state.listLinkedPrograms = listLinkedPrograms;
      // For rounding to 2 decimal points
      state.programs.partners.map((element: Partner) => {
        element.ratio = parseFloatWithDecimal(element.ratio.toString(), 2);

        return element;
      });

      setState({ ...state, state });
    })();
  }, []);

  return (
    <div id='container-item' className='read-only'>
      <Heading name={main_program} style={{ margin: ' 0px' }} />
      <InstructionWrapper row>
        <TextField readOnly label='Identifier' value={main_program} />
        <TextField
          readOnly
          label='Partners Program Name'
          value={programs.name}
        />
      </InstructionWrapper>
      <InstructionWrapper text='Enter the main program name here.' row>
        <TextField
          label='Display Name of Program'
          value={display_program}
          readOnly
        />
        <TextField
          label='Value (Cents)'
          value={currency.value_cents}
          type={'number'}
          readOnly
        />

        <List
          readOnly
          className='top-margin'
          label={`Category`}
          value={category}
          options={awardProgramCategories}
          getOptionLabel={(o) => {
            return `${o}`;
          }}
          getOptionValue={(o) => {
            return `${o}`;
          }}
          groupBy={(o) => o.substring(0, 1)}
          isOptionEqualToValue={(o, v) => `${o}` === `${v}`}
        />
      </InstructionWrapper>

      <Heading name='Status Levels' />

      <div className='program-container'>
        {status_levels_keys &&
          status_levels_keys.map((k: keyof StatusLevels, index: number) => {
            return (
              <div key={k + index} className='program-card'>
                <TextField
                  readOnly
                  className='full-width remove-auto-style'
                  label={k}
                  value={status_levels[k]}
                ></TextField>
              </div>
            );
          })}
      </div>

      <Heading style={{ margin: '12px 0px' }} name='Transfer Partners' />

      {state.programs.partners.map((partner: Partner, index: number) => {
        return (
          <div key={'partner_' + index}>
            {
              <Card
                key={partner.program}
                className='program-card-edit page-padding'
              >
                <TextField
                  value={index + 1}
                  style={{ width: '40px' }}
                  readOnly
                ></TextField>

                <TextField
                  readOnly
                  className='next-each-other'
                  label={'Identifier'}
                  value={partner.program_name}
                ></TextField>

                <TextField
                  readOnly
                  className='next-each-other'
                  label={'Ratio'}
                  value={partner.ratio}
                  type={'number'}
                ></TextField>
              </Card>
            }
          </div>
        );
      })}

      <Heading style={{ margin: '12px 0px' }} name='Linked Partners' />

      <div className='program-card-grid'>
        {state &&
          state.listLinkedPrograms &&
          state.listLinkedPrograms.map(
            (partner: linkedPartners, index: number) => {
              return (
                <Card
                  key={`${partner.display_program}-${index}`}
                  className='linked-transfer'
                >
                  <TextField
                    readOnly
                    className='next-each-other'
                    label={'Linked Program'}
                    value={partner.display_program}
                  ></TextField>

                  <TextField
                    readOnly
                    className='next-each-other'
                    label={'Ratio'}
                    value={partner.ratio}
                    type={'number'}
                  ></TextField>
                </Card>
              );
            }
          )}
      </div>

      <InstructionWrapper text='' row>
        <div className='program-container'></div>
      </InstructionWrapper>
    </div>
  );
}
